import type { PipeMiddlewareElement } from '../../middleware-pipe';
import type { MiddlewarePipeDetails } from '../../models/middleware-pipe-details.model';
import type { SearchTab } from '../../../../components/result-page/search-tab/search-tab';
import type { SearcherType } from '../../../../models/cose-api/types/searcher.type';
import type { AutocorrectEv } from '../../../../api/model/response/documents/public/Autocorrect';
import { callCoseApi } from '../api-calls/call-cose-api';
import { authenticationHeaders } from '../../../../components/guided/subcomponents/utils';
import type {CoseQueryBodyRequest} from '../../../../models/cose-api/request/query-body-request.model';
import type {DashboardMisspellings} from '../../../../components/result-page/search-tab/subcomponents/dashboard-tab-view/dashboard-misspellings/dashboard-misspellings';

//DRUTY: ten middleware jest do przepisania, gdy będziemy poprawia autokorektę
//istineje TYLKO dlatego ze mechanizm autokorekty potrzebuje 6 osob aby zrozumiec jak dziala
//caly kod poza linijka z czyszczeniem filtrow na potrzebe autokoretky - powinien byc taki sam jak build-query-after-events
export const reqResCoseBuildQueryAfterEventsWithInitialFilters: PipeMiddlewareElement<

    MiddlewarePipeDetails,
    any//eslint-disable-line
> = async (
  details: MiddlewarePipeDetails,
  next: PipeMiddlewareElement<MiddlewarePipeDetails, any> | undefined //eslint-disable-line
): Promise<any> => { //eslint-disable-line

    const searchTab: SearchTab | DashboardMisspellings = details.context;
    const defaultBody:CoseQueryBodyRequest = {
      searcher: (searchTab.alternativeSearcherActive ? searchTab.alternativeSearcher : searchTab.tabName) as SearcherType,
      country: searchTab.country,
      language: searchTab.language,
      term: searchTab.query,
    };
    let autocorrectEv: AutocorrectEv = {
      totalHits: null,
      suggestion: '',
      isAutocorrect: false,
      hasHitsError: false,
    };

    if (searchTab.apigeeTokenUrl && searchTab.apigeeAuth) {
      const headers = await authenticationHeaders({tokenUrl: searchTab.apigeeTokenUrl, apigeeBasicAuth: searchTab.apigeeAuth});

      if(headers['Authorization']) {
        const authHeader = headers['Authorization'];
        details.additionalData = { ...details?.additionalData, ...{ authHeader } };
      }
    }

    //Required body data
    details.middlewareRequest.requestBody = details.middlewareRequest
      .requestBody
      ? { ...details.middlewareRequest.requestBody, ...defaultBody }
      : defaultBody;

    //Spealcheck
    details.middlewareRequest.requestBody.forceTerm =
        details.additionalData?.skipAutocorrection ||
        !searchTab.runAutocorrect ||
        searchTab.skipAutocorrection;

    //Sorting
    details.middlewareRequest.requestBody.sort = details.additionalData?.sort;

    //Per-tab loading
    if(!searchTab.isVisible && searchTab.optimizedLoading){
      details.middlewareRequest.requestBody.sortOptions = {
        'fetch': false
      };
      details.middlewareRequest.requestBody.facetsOptions = {
        'fetch': false
      };
    }

    //Pagination
    const currentPage = searchTab.currentPage || 1;
    const offset = (currentPage - 1) * searchTab.perPage;
    const pagination = {
      limit: searchTab.optimizedLoading && !searchTab.isVisible ? searchTab.optimizedLoadingLimit : searchTab.perPage,
      offset,
    };
    details.middlewareRequest.requestBody.pagination = details.middlewareRequest
      .requestBody.pagination
      ? { ...pagination, ...details.middlewareRequest.requestBody.pagination }
      : pagination;

    if(searchTab.isDashboardView) {
      details.middlewareRequest.requestBody.pagination = {
        limit:0,
        offset:0
      };
      details.middlewareRequest.requestBody.sortOptions = {
        'fetch': false
      };
      details.middlewareRequest.requestBody.facetsOptions = {
        'fetch': false
      };
    }
    const response = await next(details);

    //@ts-ignore
    searchTab?.facetService?.setFacets(response.facetsOptions);

    if ((searchTab.isAutocorrectEndpoint && details.middlewareRequest.requestBody.pagination.offset === 0)
      && !details.middlewareRequest.requestBody.sort || (searchTab.isAutocorrectEndpoint && searchTab.isDashboardView)) {
      const pagination = {
        limit: 0,
        offset,
      };
      details.middlewareRequest.requestBody.forceTerm = true;
      details.middlewareRequest.requestBody.pagination = details
        .middlewareRequest.requestBody.pagination
        ? {
          ...details.middlewareRequest.requestBody.pagination,
          ...pagination,
        }
        : pagination;

      await callCoseApi(details).then((result) => {
          return (autocorrectEv = {
            ...autocorrectEv,
            totalHits: result.stats.totalHits,
          });
      });
    }

    searchTab.reflectedState = {
      ...searchTab.reflectedState,
      ajaxIsLoading: false,
      hasError: false,
      count: response.stats.totalHits
    };

    const suggestions = response.suggestions?.find(
      (item) => item.type === 'suggestion/spellcheck'
    );

    searchTab.queryResult = { ...response, suggestion: suggestions?.text};
    searchTab.queryResult.searcher = response.searcher;
    searchTab.queryResult.searchResults = {};
    searchTab.queryResult.searchResults.totalHits = response.stats.totalHits;

    const ev = {
      count: searchTab.queryResult?.stats?.totalHits,
      term: searchTab.queryResult?.term ?? searchTab.query,
      tab: searchTab.tabName,
      ajaxIsLoading: false,
    };

    searchTab.searchCompleted.emit({
      ...searchTab.reflectedState,
      ...ev,
      documents: response.documents,
    });

    const relatedProducts = response.suggestions.filter(item => item.type === 'suggestion/quicklink');

    // Fallback, if more quicklinks exist, because backend can not provide more dependable field or change quickling name for now
    if (relatedProducts.length > 1) relatedProducts.suggestions.filter(item => item.text === 'TeSensors');

    if (relatedProducts[0]?.text) {
      // Custom event created to support more,
      // Than only search-tab, as we have also Dashboard View
      const relatedProductEvent = new CustomEvent('search:SearchResultsRelatedProduct', { detail: { relatedProduct: relatedProducts[0]?.text }});

      window.dispatchEvent(relatedProductEvent);
    }

    if (currentPage === 1) {
      searchTab.aggregatedResults = [];
    }
    if (details.additionalData?.skipAutocorrection) {
      searchTab.aggregatedResults = [...searchTab.queryResult.documents];
    } else {
      searchTab.aggregatedResults = [
        ...searchTab.aggregatedResults,
        ...searchTab.queryResult.documents,
      ];
    }


    if (searchTab.queryResult.suggestions?.length && suggestions &&
			(autocorrectEv.totalHits !== null || autocorrectEv.hasHitsError)) {
      autocorrectEv = {
        ...autocorrectEv,
        suggestion: suggestions?.text,
        isAutocorrect: true,
      };

      searchTab.searchAutocorrect.emit({
        ...autocorrectEv,
      });
    }

    if (
      searchTab.queryResult.suggestion === searchTab.query &&
        searchTab.isAutocorrectEndpoint
    ) {
      autocorrectEv = {
        ...autocorrectEv,
        isAutocorrect: false,
      };

      searchTab.searchAutocorrect.emit({
        ...autocorrectEv,
      });
    }

    return new Promise((r) => r(response));
};
